// import { TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useState } from 'react';
import TableCompHead from '../../../../components/ui/TableCompHead';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import { useQuery } from '../../../../hooks/UseQuery';

interface IProps {
  moduleData: any;
  isView: boolean;
  machineData: any;
}

const numberCol = Array.from({ length: 31 }, (_, index) => index + 1);

const theadData = [
  'Sr.No.',
  'Check Point',
  'Check Outline',
  ...numberCol,
  'Remarks',
];
// colspan 38

const THead = ({ moduleData, isView, machineData }: IProps) => {
  const [render, setRender] = useState(false);
  const annual_month = useQuery('annual_date') || '';
  return (
    <thead>
      <TableCompHead
        colSpan={35}
        rowSpan={3}
        labels={['Doc. No.', 'Rev. No.', 'Date']}
        values={['FM/MAINT/06', '01', '04.05.2020']}
        heading="Daily Machine Check Sheet"
      />
      <tr>
        <th colSpan={2} align="left">
          Date :{' '}
        </th>
        <th colSpan={3} align="left">
          {isView ? (
            formatDate(moduleData.moduleData_date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.moduleData_date)}
              onChange={(date) => {
                moduleData.moduleData_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
        <th colSpan={30}></th>
      </tr>
      <tr>
        <th colSpan={5} align="left">
          Machine No. :-
          {isView ? (
            moduleData?.machine_id?.machine_no
          ) : (
            <AutocompleteMuiCustom
              id="Machine"
              label=""
              option_name="machine_no"
              arrayofObj={machineData}
              value={moduleData?.machine_id || ''}
              onChange={(e, value) => {
                moduleData.machine_id = value;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
        <th colSpan={20}></th>

        <th colSpan={15} align="left">
          Month: {moduleData.annual_month || annual_month}
        </th>
      </tr>
      <tr>
        {theadData.map((heading, index) => (
          <th key={heading} colSpan={heading === 'Remarks' ? 2 : 1}>
            {heading}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
